import type { NextPage } from 'next'
import { buttonVariants } from '@cocoonspace/ui/components/button'
import { useLingui } from '@lingui/react/macro'
import { ArrowRightIcon } from 'lucide-react'

import { MainContainer } from '~/components/atoms/main-container'
import { LocalizedLink as Link } from '~/components/localized-link'
import { MyEventsCalendar } from '~/domains/events/components/my-events-calendar'
import { HasExperiment } from '~/hooks/use-experiment'
import { BookingRequests } from './booking-requests'
import { InvoicesGraph } from './invoices-graph'
import { QuotationRequests } from './quotation-requests'
import { UserRecap } from './user-recap'

export const DashboardPage: NextPage = () => {
	const { t } = useLingui()

	return (
		<MainContainer>
			<UserRecap />
			<HasExperiment experimentId='quotations-beta'>
				<QuotationRequests />
			</HasExperiment>
			<BookingRequests />

			<div className='flex flex-col gap-4'>
				<div className='flex flex-col items-start justify-between md:flex-row md:items-end'>
					<h2 className='text-3xl font-bold'>{t`Mes évènements`}</h2>

					<Link
						className={buttonVariants({
							className: 'gap-1',
							variant: 'textPrimary',
						})}
						href='/events'
					>
						{t`Voir les évènements`}
						<ArrowRightIcon className='!size-3' />
					</Link>
				</div>
				<MyEventsCalendar />
			</div>

			<InvoicesGraph />
		</MainContainer>
	)
}
